var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 119.11 119.11"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M119.11 20.33 98.79 0 88.35 10.43 11.1 87.68a2 2 0 0 0-.45.71l-10.52 28A2 2 0 0 0 2 119.11a2.1 2.1 0 0 0 .7-.12l28-10.52a2 2 0 0 0 .71-.46l78.69-78.67ZM98.79 5.66l14.67 14.67-4.78 4.77L94 10.43Zm-85.32 86.6 13.38 13.39-21.43 8Zm15.44 12.62 1.41-1.42-14.67-14.67-1.41 1.41 76.94-76.94 7.34 7.33 7.34 7.34Z",
  "data-name": "Layer 1"
}))));
export default SvgEdit;